/** Ponte com o DF-e: notas do mês de um cliente (faturamento encontrado e compras), para conferência na apuração. */
import { z } from 'zod';
import { CompetenciaChave, CompetenciaChaveQuery } from './comum.js';

export const DfeConfig = z.object({ ligado: z.boolean(), /** começo da chave, só para reconhecer qual é */ prefixo: z.string().nullable(), ultimoOkEm: z.string().nullable(), ultimoErro: z.string().nullable() });
export type DfeConfig = z.infer<typeof DfeConfig>;
export const DfeLigarBody = z.object({ chave: z.string().trim().min(16).max(200) });
const Grupo = z.object({ quantidade: z.number().int(), valor: z.number(), porTipo: z.array(z.object({ tipo: z.string(), quantidade: z.number().int(), valor: z.number() })) });
export const DfeMovimento = z.object({
  competenciaChave: CompetenciaChave,
  /** documentos AUTORIZADOS em que o cliente é o emitente (o que o DF-e capturou — confira se é tudo) */
  emitidas: Grupo,
  /** documentos AUTORIZADOS emitidos contra o cliente (compras) */
  recebidas: Grupo,
  /** NFS-e emitidas PELO DF-e com competência no mês */
  nfseEmitidas: z.object({ quantidade: z.number().int(), valor: z.number() }),
  canceladas: z.number().int(),
  /** só o resumo chegou (sem XML completo / sem protocolo): ficam fora da soma */
  semXml: z.number().int(),
  consultadoEm: z.string(),
});
export type DfeMovimento = z.infer<typeof DfeMovimento>;
export const DfeMovimentoQuery = z.object({ competenciaChave: CompetenciaChaveQuery.optional() });
